export default function(constantArray) {
  return constantArray.reduce((hash, obj) => ({ ...hash, [obj]: obj }), {})
}
